/* eslint-disable import/no-unresolved */
/* eslint-disable import/first */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import $ from 'jquery';
import axios from 'axios';
import {
    PAGE_HOME, PAGE_THREATS,
    PAGE_EBOOK, PAGE_OFFER, PAGE_CONTACT,
    PAGE_PRIVACY, PAGE_LEGAL, PAGE_WEBINAR,
    PAGE_ABOUT, PAGE_ESTIMATION
} from './config/pages';
import Sentry from './lib/sentry';

import Preloader from './components/Preloader';
import Header from './components/header/Header';
import Switch from './components/Switch';
import BackToTop from './components/BackToTop';
import Cover from './components/Cover';
import VideoModal from './components/modals/VideoModal';
import MainContent from './components/content/MainContent';
import Contact from './components/content/Contact';
import Ebook from './components/content/ebook/Ebook';
import EbookDownload from './components/content/ebook/EbookDownload';
import PrivacyPolicy from './components/content/PrivacyPolicy';
import LegalNotice from './components/content/LegalNotice';
import Webinar from './components/content/webinar/Webinar';
import WebinarSubscribed from './components/content/webinar/WebinarSubscribed';
import About from './components/content/About';
import Estimation from './components/content/Estimation';
import { getCMSBrand, getCmsCompanyInfo } from './components/helpers/fetchCmsContent';
import Directus from './components/helpers/directusLink';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breakpoint: '',
            disableTransitionTimeout: null,
            preloaderDone: false,
            noTransition: false,
            companyInfo: null,
            consents: {
                contact: {
                    id: 2,
                    label: '<a></a>',
                    name: 'CONTACT',
                    text: ''
                },
                marketing: {
                    id: 3,
                    label: '<a></a>',
                    name: 'MARKETING',
                    text: ''
                },
                rodo: {
                    id: 4,
                    label: '<a></a>',
                    name: 'INFORMATION_CLAUSE',
                    text: ''
                }
            },
            brandCmsContent: ''
        };

        this.updateBreakpoint = this.updateBreakpoint.bind(this);
        this.disableTransition = this.disableTransition.bind(this);
        this.preloaderFinished = this.preloaderFinished.bind(this);
        this.scrollLiveChat = this.scrollLiveChat.bind(this);
        this.fetchConsents = this.fetchConsents.bind(this);
        this.generateSessionId = this.generateSessionId.bind(this);
        this.fetchCmsBrand = this.fetchCmsBrand.bind(this);

        this.liveChatReady = false;
    }

    componentWillMount() {
        this.fetchConsents(this.props.language);
        this.generateSessionId();

        if (this.props.page === PAGE_WEBINAR
            || this.props.page === PAGE_EBOOK
            || !this.props.firstLoad
            || document.referrer.indexOf('blog.lemlock.com') !== -1
            || document.referrer.indexOf('scanner.lemlock.com') !== -1
        ) {
            this.setState({
                preloaderDone: true
            });
        }
    }

    componentDidMount() {
        this.fetchCmsBrand();
        this.fetchCmsCompanyInfo();
        if (this.state.breakpoint === '') {
            this.updateBreakpoint();
        }
        window.addEventListener('resize', this.updateBreakpoint);
        window.addEventListener('resize', this.disableTransition);
        window.addEventListener('resize', this.scrollLiveChat);
        window.addEventListener('scroll', this.scrollLiveChat);
    }

    componentWillReceiveProps(nextProps) {
        const { language } = this.props;

        if (language !== nextProps.language) {
            this.fetchConsents(nextProps.language);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateBreakpoint);
        window.removeEventListener('resize', this.disableTransition);
        window.removeEventListener('resize', this.scrollLiveChat);
        window.removeEventListener('scroll', this.scrollLiveChat);
    }

    updateBreakpoint() {
        const breakpoint = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
        if (breakpoint === 'phone' && window.innerWidth >= 768) {
            setTimeout(this.updateBreakpoint, 10);
        }
        this.setState({
            breakpoint
        }, () => {
            if (this.state.breakpoint === '') {
                setTimeout(() => {
                    this.updateBreakpoint();
                }, 10);
            }
        });
    }

    disableTransition() {
        clearTimeout(this.state.disableTransitionTimeout);
        this.setState({ noTransition: true });
        const timeout = setTimeout(() => {
            this.setState({ noTransition: false });
        }, 100);
        this.setState({ disableTransitionTimeout: timeout });
    }

    scrollLiveChat() {
        if (this.state.breakpoint === 'phone' && typeof window.LC_API !== 'undefined') {
            if (window.LC_API.chat_window_maximized()) {
                return;
            }
            const documentHeight = $(document).height();
            const windowHeight = $(window).height();
            const scrollTop = $(window).scrollTop();
            const footerHeight = ($('.container-footer-small').length > 0)
                ? $('.container-footer-small').outerHeight(true)
                : $('.container-footer').outerHeight(true);
            const hidePoint = documentHeight - windowHeight - footerHeight;
            try {
                if (scrollTop > hidePoint) {
                    window.LC_API.hide_chat_window();
                } else {
                    window.LC_API.minimize_chat_window();
                }
            } catch (e) {
                $.noop(e);
            }
        }
    }

    fetchConsents = (lang) => {
        const { t } = this.props;

        const consentsDefault = {
            contact: {
                id: 2,
                label: `${ t('consent.common.dataStart') } <a>${ t('consent.common.dataEnd') }</a>`,
                name: 'CONTACT',
                text: t('consent.data.general').join(', ')
            },
            marketing: {
                id: 3,
                label: `${ t('consent.common.dataStart') } <a>${ t('consent.common.marketingEnd') }</a>`,
                name: 'MARKETING',
                text: t('consent.marketing.list').join(', ')
            },
            rodo: {
                id: 4,
                label: `${ t('consent.common.rodoStart') } <a>${ t('consent.common.rodoEnd') }</a>`,
                name: 'INFORMATION_CLAUSE',
                text: t('consent.rodo.general').join(', ')
            }
        };
        this.setState({
            consents: consentsDefault
        });

        axios({
            method: 'get',
            url: `${ process.env.CONSENTS }/?brandDomain=lemlock.pl&language=${ lang }`,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((response) => {
                const consentsToSave = {
                    contact: response.data.find((x) => x.name === 'CONTACT'),
                    marketing: response.data.find((x) => x.name === 'MARKETING'),
                    rodo: response.data.find((x) => x.name === 'INFORMATION_CLAUSE')
                };
                this.setState({
                    consents: consentsToSave
                });
            })
            .catch((err) => {
                Sentry.captureException(err);
                this.setState({
                    consents: consentsDefault
                });
            });
    }

    preloaderFinished() {
        this.setState({
            preloaderDone: true
        });
    }

    // eslint-disable-next-line class-methods-use-this
    generateSessionId() {
        const id = new Date().toISOString().replaceAll(/[. ,:-]+/g, '') + Math.random().toString().slice(2, 6);
        sessionStorage.setItem('session_id', id);
        if (id) {
            Sentry.setTag('session_id', id);
        }
    }

    async fetchCmsBrand() {
        const brandCmsContent = await getCMSBrand();
        this.setState({ brandCmsContent });
    }
    async fetchCmsCompanyInfo() {
        const companyInfo = await getCmsCompanyInfo();
        this.setState({ companyInfo });
    }

    claim() {
        const { brandCmsContent } = this.state;
        if (!brandCmsContent || !brandCmsContent.translations) return '';

        const translation = Directus.getTranslationByLang(brandCmsContent.translations, this.props.language, ['claim']);
        if (translation) return translation.claim || '';
        return '';
    }

    render() {
        const {
            breakpoint, preloaderDone, noTransition, companyInfo
        } = this.state;
        const {
            language, page, subpage, query, firstLoad, openPage, t, hash
        } = this.props;

        const claim = this.claim();

        const transitionClasses = {
            appear: 'app-page-hide',
            appearActive: 'app-page-hide',
            enter: 'app-page-hide',
            enterActive: 'app-page-hide',
            exit: 'app-page-show',
            exitActive: 'app-page-show'
        };

        return (
            <div>
                { !preloaderDone && <Preloader
                  preloaderFinished={ this.preloaderFinished }
                  noTransition={ noTransition }
                  claim={ claim }
                /> }
                {
                    (page !== PAGE_WEBINAR && page !== PAGE_EBOOK) &&
                        <Header
                          t={ t }
                          openPage={ openPage }
                          language={ language }
                          page={ page }
                          subpage={ subpage }
                          breakpoint={ breakpoint }
                          noTransition={ noTransition }
                        />
                }
                <Switch
                  type="prev"
                  t={ t }
                  openPage={ openPage }
                  language={ language }
                  page={ page }
                  noTransition={ noTransition }
                />
                <Switch
                  type="next"
                  t={ t }
                  openPage={ openPage }
                  language={ language }
                  page={ page }
                  noTransition={ noTransition }
                />
                { breakpoint !== 'phone' && page !== PAGE_HOME && <BackToTop page={ page }/> }
                <Cover
                  type="prev"
                  page={ page }
                  firstLoad={ firstLoad }
                />
                <Cover
                  type="next"
                  page={ page }
                  firstLoad={ firstLoad }
                />
                <EbookDownload
                  t={ t }
                  openPage={ openPage }
                  language={ language }
                  page={ page }
                  subpage={ subpage }
                  query={ query }
                  claim={ claim }
                />
                <WebinarSubscribed
                  t={ t }
                  openPage={ openPage }
                  language={ language }
                  page={ page }
                  subpage={ subpage }
                  query={ query }
                />
                <TransitionGroup className="app-transition" id="app-transition">
                    {
                        page === PAGE_HOME || page === PAGE_OFFER || page === PAGE_THREATS ? (
                            <CSSTransition
                              timeout={ 500 }
                              key="main-content"
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <MainContent
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          subpage={ subpage }
                                          preloaderDone={ preloaderDone }
                                          pageTransitionState={ state }
                                          breakpoint={ breakpoint }
                                          noTransition={ noTransition }
                                          consents={ this.state.consents }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                    {
                        page === PAGE_EBOOK ? (
                            <CSSTransition
                              timeout={ 500 }
                              key={ PAGE_EBOOK }
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <Ebook
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          subpage={ subpage }
                                          breakpoint={ breakpoint }
                                          pageTransitionState={ state }
                                          consents={ this.state.consents }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                    {
                        page === PAGE_WEBINAR ? (
                            <CSSTransition
                              timeout={ 500 }
                              key={ PAGE_WEBINAR }
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <Webinar
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          subpage={ subpage }
                                          pageTransitionState={ state }
                                          consents={ this.state.consents }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                    {
                        page === PAGE_CONTACT ? (
                            <CSSTransition
                              timeout={ 500 }
                              key={ PAGE_CONTACT }
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <Contact
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          pageTransitionState={ state }
                                          consents={ this.state.consents }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                    {
                        page === PAGE_ABOUT ? (
                            <CSSTransition
                              timeout={ 500 }
                              key={ PAGE_ABOUT }
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <About
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          pageTransitionState={ state }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                    {
                        page === PAGE_ESTIMATION ? (
                            <CSSTransition
                              timeout={ 500 }
                              key={ PAGE_ESTIMATION }
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <Estimation
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          pageTransitionState={ state }
                                          preloaderDone={ preloaderDone }
                                          firstLoad={ firstLoad }
                                          breakpoint={ breakpoint }
                                          hash={ hash }
                                          consents={ this.state.consents }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                    {
                        page === PAGE_PRIVACY ? (
                            <CSSTransition
                              timeout={ 500 }
                              key={ PAGE_PRIVACY }
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <PrivacyPolicy
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          pageTransitionState={ state }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                    {
                        page === PAGE_LEGAL ? (
                            <CSSTransition
                              timeout={ 500 }
                              key={ PAGE_LEGAL }
                              classNames={ transitionClasses }
                            >
                                {
                                    (state) => (
                                        <LegalNotice
                                          t={ t }
                                          openPage={ openPage }
                                          language={ language }
                                          page={ page }
                                          pageTransitionState={ state }
                                          claim={ claim }
                                          companyInfo={ companyInfo }
                                        />
                                    )
                                }
                            </CSSTransition>
                        ) : null
                    }
                </TransitionGroup>
                <VideoModal
                  t={ t }
                  breakpoint={ breakpoint }
                  openPage={ openPage }
                  language={ language }
                  page={ page }
                  subpage={ subpage }
                  query={ query }
                  claim={ claim }
                />
            </div>
        );
    }
}

App.defaultProps = {
    subpage: null,
    query: {},
    hash: null
};

App.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    query: PropTypes.objectOf(PropTypes.string),
    firstLoad: PropTypes.bool.isRequired,
    hash: PropTypes.string
};

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx